import * as React from 'react';
import styled, { css } from 'styled-components';
import { getItem } from '@/redux/modules/item';
import { getThumbnailItemImageUrl } from '@/utils/urls';
import ImageWithFallback from '@liveauctioneers/caterwaul-components/lib/ImageWithFallback/ImageWithFallback2';
import { useSelector } from 'react-redux';

type Props = {
    active: boolean;
    alt: string;
    className?: string;
    imgNumber: number;
    itemId: number;
    onClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

const Thumbnail = ({ active, alt, className, imgNumber, itemId, onClick }: Props) => {
    const { catalogId, imageVersion, sellerId } = useSelector((state) => getItem(state, itemId));
    const thumbnail = getThumbnailItemImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 54);
    const thumbnailPlaceholder = getThumbnailItemImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 54, 1);

    return (
        <StyledThumbnailWrapper className={className}>
            <StyledThumbnail active={active} onClick={onClick}>
                <StyledThumbnailImage alt={alt} placeholder={thumbnailPlaceholder} src={thumbnail} />
            </StyledThumbnail>
        </StyledThumbnailWrapper>
    );
};

export default Thumbnail;

interface ThumbnailProps {
    active: boolean;
}

const StyledThumbnail = styled.div<ThumbnailProps>`
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.grey400};
    cursor: pointer;
    text-align: center;
    width: 56px;
    height: 56px;
    margin: 0 1px 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media print {
        display: none;
    }

    ${({ active }) =>
        active
            ? css`
                  border: 1px solid ${({ theme }) => theme.colors.blue100};
              `
            : ''}
`;

const StyledThumbnailWrapper = styled.div`
    display: block;
    width: 58px;
`;

const StyledThumbnailImage = styled(ImageWithFallback)`
    max-width: 54px;
    max-height: 54px;
`;
